// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MessageLines: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29 29"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M25.45.5h-21C2.522.5.95 2.083.95 3.975v15.81c0 1.941 1.572 3.475 3.5 3.475H9.7v4.576c0 .542.603.856 1.046.534l6.83-5.16h7.875c1.928 0 3.5-1.583 3.5-3.475V3.975A3.48 3.48 0 0025.45.5zm1.8 19.384c0 .97-.788 1.762-1.75 1.762h-7.881c-.38 0-.748.124-1.05.353l-5.07 3.832v-3.304a.878.878 0 00-.875-.88H4.5c-.962 0-1.75-.794-1.75-1.763V4.024c0-.969.788-1.762 1.75-1.762h21c.963 0 1.75.793 1.75 1.762v15.86zm-11.376-6.168h-7a.88.88 0 00-.875.881c-.049.485.394.882.875.882h7c.482 0 .826-.398.826-.882s-.345-.88-.826-.88zm5.25-5.286H8.874A.88.88 0 008 9.31c-.049.486.394.882.875.882h12.25c.482 0 .826-.397.826-.882 0-.484-.345-.88-.826-.88z" />
        </svg>
    );
};

export default React.memo(MessageLines);
